import { useState } from 'react'
import { TelegramShareButton, WhatsappShareButton } from 'react-share'
import {
  CommentIcon,
  DiscordIcon,
  HeartIcon,
  TelegramIcon,
  TiktokIcon,
  WhatsappIcon,
} from '../../ui/icons/shared'
import { GreyDivider } from '../../ui/elements'

export const PostDetailsMobileFooter = (props) => {
  let selectedPost = props.selectedPost
  let articelsHomePageImages = props.articelsHomePageImages
  const { loggedInUser, handleToggleLike } = props

  const [isShareOpen, setIsShareOpen] = useState(false) // ניהול מצב שיתוף

  const toggleShareOptions = () => {
    setIsShareOpen((prevState) => !prevState)
  }

  return (
    <div className="lg:hidden fixed bottom-[-1px] z-10 left-0 right-0 bg-secondaryBackground rounded-b-md ">
   

       <GreyDivider className="hidden lg:block" />

      <div className="flex justify-between my-4 px-4">
        <div className="flex gap-4">
          <div className="flex gap-2 items-center">
            <CommentIcon />
            <span>{selectedPost.commentCount ?? 0}</span>
          </div>
          <div className="flex gap-2 items-center">
            <HeartIcon
              onClick={handleToggleLike}
              className={`cursor-pointer transition-colors duration-200 ${
                selectedPost.likes.includes(loggedInUser?._id)
                  ? 'text-primary'
                  : ' hover:text-primary'
              }`}
            />
            <span>{selectedPost.likes?.length || 0}</span>
          </div>
        </div>
        <button onClick={toggleShareOptions}>
          <div className="flex gap-2 items-center">
            <img src={articelsHomePageImages.shareMobileBtn} alt="Share" />
            <h4 className="text-primary">שיתוף</h4>
          </div>
        </button>
      </div>

      {isShareOpen && (
        <div className="flex gap-4 items-center p-4 justify-end">
          <WhatsappShareButton
            url={window.location.href}
            title={selectedPost.title}
          >
            <WhatsappIcon className="text-primary w-6 h-6" />
          </WhatsappShareButton>
          <TelegramShareButton
            url={window.location.href}
            title={selectedPost.title}
          >
            <TelegramIcon className="text-primary w-6 h-6" />
          </TelegramShareButton>
          <button
            onClick={async () => {
              await navigator.clipboard.writeText(window.location.href)
              toast.success('קישור הועתק לשיתוף בטיקטוק!')
            }}
          >
            <TiktokIcon className="text-primary w-6 h-6" />
          </button>
          <button
            onClick={async () => {
              await navigator.clipboard.writeText(window.location.href)
              toast.success('קישור הועתק לשיתוף בדיסקורד!')
            }}
          >
            <DiscordIcon className="text-primary w-6 h-6" />
          </button>
        </div>
      )}
    </div>
  )
}
